import { SearchState } from '@shared/search/state'

/**
 * Whether the timeline shows items the member received or the ones they gave.
 * The values are persisted in the filter state, so they double as the ids of
 * the Received/Given chips.
 */
export enum TimelineDirection {
  RECEIVED = 'received',
  GIVEN = 'given',
}

export type TimelineItemTypeFilterField = 'itemTypeIn' | 'direction'

export type TimelineItemTypeFilterProps = {
  filters: Partial<SearchState<TimelineItemTypeFilterField>>
  onFilter: (filters: Partial<SearchState<TimelineItemTypeFilterField>>) => void
}
